module.exports = __webpack_public_path__ + "static/media/mod_risev2_2.a6371b35.jpg";